/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".preview-box[_ngcontent-%COMP%] {\n  width: 800px;\n  background: #ffffff;\n  border: 1px solid #DFE1E9;\n  border-radius: 5px;\n  padding: 1.5rem;\n  font-size: 15px;\n  font-family: 'TH Sarabun New', serif, sans-serif, cursive, fantasy, monospace; }\n\ntable.table-info[_ngcontent-%COMP%], th[_ngcontent-%COMP%], td[_ngcontent-%COMP%] {\n  border: 1px solid black;\n  border-collapse: collapse;\n  background-color: #ffffff;\n  padding: 1rem; }\n\n.img-logo[_ngcontent-%COMP%] {\n  width: 75px;\n  margin-left: 40px;\n  margin-right: 40px;\n  vertical-align: middle; }\n\n.company-name[_ngcontent-%COMP%] {\n  font-size: 25px;\n  font-weight: bold; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/preview-logo/preview-logo.component.scss.shim.ngstyle.js.pre-build-optimizer.js